const CACHE_KEY = "clientRegistrationTokenPrefill";

export type ClientRegistrationPrefill = {
    quoteId: number;
    brandId: number;
    client: {
        id: number;
        firstName: string;
        lastName: string;
        email: string;
        countryCode: string;
        phoneNumber: string;
    };
    quoteSummary: Record<string, unknown> | null;
};

function pickStr(r: Record<string, unknown>, camel: string, pascal: string) {
    const v = r[camel] ?? r[pascal];
    return v == null ? "" : String(v);
}

function pickNum(r: Record<string, unknown>, camel: string, pascal: string) {
    const v = r[camel] ?? r[pascal];
    return v == null ? 0 : Number(v);
}

function mapQuoteSummary(raw: unknown): Record<string, unknown> | null {
    if (!raw || typeof raw !== "object") return null;
    return raw as Record<string, unknown>;
}

function mapClient(raw: unknown): ClientRegistrationPrefill["client"] {
    const r = (raw && typeof raw === "object" ? raw : {}) as Record<string, unknown>;
    return {
        id: pickNum(r, "id", "Id"),
        firstName: pickStr(r, "firstName", "FirstName"),
        lastName: pickStr(r, "lastName", "LastName"),
        email: pickStr(r, "email", "Email"),
        countryCode: pickStr(r, "countryCode", "CountryCode") || "+353",
        phoneNumber: pickStr(r, "phoneNumber", "PhoneNumber"),
    };
}

function mapRegistrationBootstrap(raw: unknown): ClientRegistrationPrefill | null {
    if (!raw || typeof raw !== "object") return null;
    const r = raw as Record<string, unknown>;
    const quoteId = pickNum(r, "quoteId", "QuoteId");
    const brandId = pickNum(r, "brandId", "BrandId");
    if (!(quoteId > 0) || !(brandId > 0)) return null;
    return {
        quoteId,
        brandId,
        client: mapClient(r.client ?? r.Client),
        quoteSummary: mapQuoteSummary(r.quoteSummary ?? r.QuoteSummary),
    };
}

export function mapApplyOnResponse(raw: unknown): {
    quoteId: number;
    isClientUser: boolean;
    canProceedWithApplication: boolean;
    quoteProviderPriceId: number;
    registrationToken: string | null;
    prefill: ClientRegistrationPrefill | null;
} {
    const r = (raw && typeof raw === "object" ? raw : {}) as Record<string, unknown>;
    const token = pickStr(r, "registrationToken", "RegistrationToken") || null;
    const prefillRaw = r.registrationBootstrap ?? r.RegistrationBootstrap;
    return {
        quoteId: pickNum(r, "quoteId", "QuoteId"),
        isClientUser: r.isClientUser === true || r.IsClientUser === true,
        canProceedWithApplication: r.canProceedWithApplication === true || r.CanProceedWithApplication === true,
        quoteProviderPriceId: pickNum(r, "quoteProviderPriceId", "QuoteProviderPriceId"),
        registrationToken: token,
        prefill: prefillRaw ? mapRegistrationBootstrap(prefillRaw) : null,
    };
}

export function cacheRegistrationPrefill(registrationToken: string, prefill: ClientRegistrationPrefill) {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify({ registrationToken, prefill }));
}
